// Wraps the app in global providers and hosts the PWA update notice.
// Ported from the reference games' AppShell.jsx.

import { useEffect, useState, type ReactNode } from "react";
import { AuthProvider } from "./auth/AuthContext.tsx";
import UpdateNotice from "./ui/UpdateNotice.tsx";
import { UPDATE_EVENT, type VersionResult } from "./native/checkAppUpdate.ts";

export default function AppShell({
  initialUpdateNotice = null,
  children,
}: {
  initialUpdateNotice?: VersionResult | null;
  children: ReactNode;
}) {
  const [updateNotice, setUpdateNotice] = useState<VersionResult | null>(
    initialUpdateNotice,
  );

  useEffect(() => {
    const onUpdate = (e: Event) =>
      setUpdateNotice((e as CustomEvent<VersionResult>).detail);
    window.addEventListener(UPDATE_EVENT, onUpdate);
    return () => window.removeEventListener(UPDATE_EVENT, onUpdate);
  }, []);

  return (
    <AuthProvider>
      {children}
      {updateNotice && (
        <UpdateNotice
          localId={updateNotice.localId}
          remoteId={updateNotice.remoteId}
        />
      )}
    </AuthProvider>
  );
}
